import React from 'react';
import PropTypes from 'prop-types';
import Container from '@amzn/awsui-components-react/polaris/container';

const CustomCalloutsContainer = ({ children }) => {
  return (
    <Container disableContentPaddings>
      <div style={{ background: 'white' }}>{children}</div>
    </Container>
  );
};

CustomCalloutsContainer.propTypes = {
  children: PropTypes.node,
};

export default CustomCalloutsContainer;
